// extracted by mini-css-extract-plugin
export default {"SocialMedia":"SocialMedia_SocialMedia__m4wdS"};